import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box, Stack } from '@mui/material';

import { getPromotionsAction } from '../../../services/request';
import { PromotionList } from './promotion/PromotionList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';
import { PromotionSidebar } from './promotion/PromotionSidebar';
import Scrollbar from '../../../components/Scrollbar';

export const PromotionRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getPromotionsAction(search, 'GET'));
  const optionsRequest = useQuery(getPromotionsAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [promotions, setPromotions] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [allSeasons, setAllSeasons] = React.useState([]);
  const [createSignal, setCreateSignal] = React.useState(false);
  const [allPeriods, setAllPeriods] = React.useState([]);
  const [allPackages, setAllPackages] = React.useState([]);
  const [allCalculationTypes, setAllCalculationTypes] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setPromotions(payload.results);
    }
  }, [loading, search]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setAllSeasons(optionsRequest.payload.actions.GET.season.choices);
      setAllPeriods(optionsRequest.payload.actions.GET.periods.choices);
      setAllPackages(optionsRequest.payload.actions.GET.packages.choices);
      setAllCalculationTypes(optionsRequest.payload.actions.GET.calculation_types.choices);
    }
  }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setPromotions(
        _.map(promotions, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setPromotions(_.filter(promotions, obj => obj.id !== obj2.id));
    } else {
      setPromotions([obj2, ...promotions]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Stack direction="row" sx={{ height: 'calc(100% + 64px)' }}>
        { !hideSidebar && (
          <PromotionSidebar
            isOpenSidebar={openSidebar}
            onCloseSidebar={() => setOpenSidebar(false)}
            createSignal={() => setCreateSignal(true)}
            queryCallback={queryCallback}
          />
        )

        }
        <PromotionList
          sx={{ flex: '1 1 90%' }}
          loading={loading}
          hideSidebar={() => setHideSidebar(!hideSidebar)}
          onOpenSidebar={() => setOpenSidebar(true)}
          promotions={promotions}
          queryCallback={queryCallback}
          submitCallback={submitCallback}
          allSeasons={allSeasons}
          createSignal={createSignal}
          turnOffCreateSignal={() => setCreateSignal(false)}
          allPeriods={allPeriods}
          allPackages={allPackages}
          allCalculationTypes={allCalculationTypes} />
      </Stack>
    </>
  );
};
